import { useState } from 'react';
import { Button, KIND, SIZE, SHAPE } from "baseui/button";
import { Input } from 'baseui/input';
import {
    LabelMedium,
    ParagraphSmall,
  } from 'baseui/typography';
import { useEffect } from 'react';
import { Page } from '../../components';
import { XBimViewer } from './components/BimViewerComponent'
import { useGetObjectsWithBimQuery } from '../../services/objects'
import {  useParams } from "react-router-dom";

export function BimViewer () {

    const prms = useParams();
    const bimId = prms.bimId;

    const securityToken = '?sv=2021-08-06&st=2023-02-23T15%3A26%3A07Z&se=2024-07-26T14%3A26%3A00Z&sr=f&sp=r&sig=A7Ar0O0vW9MBgA6nlaGhtrtLITiOspGK4kpqPfSlLsE%3D';

    //<li>https://projectxdev1storage.file.core.windows.net/bim-models/feethams_envelope.wexbim</li>
    //<li>https://projectxdev1storage.file.core.windows.net/bim-models/rac_envelope.wexbim</li>
    //<li>https://projectxdev1storage.file.core.windows.net/bim-models/BIM_RoofTop____.wexBIM</li>
  
    const [file, setFile] = useState(`https://projectxdev1storage.file.core.windows.net/bim-models/Piping.wexBIM${securityToken}`);
    const [tmpfile, setTmpFile] = useState('');
    const{ data, error: isError, isLoading, isSuccess, currentData }= useGetObjectsWithBimQuery();

    function onFileSelectionChange(e: any) {
        setTmpFile(`${e.target.value}${securityToken}`);
    }

    function onLoadFile() {
        setFile(tmpfile);
    }
 
    useEffect(() => {
            setFile(`https://projectxdev1storage.file.core.windows.net/bim-models/Piping.wexBIM${securityToken}`);
    }, [isSuccess]);


    return (
            <XBimViewer width={500} height={500} data={data} fileUrl={file} bimElement={bimId}></XBimViewer>
    ) 
}  
